<template>
  <div style="display: flex;">
    <div v-for="comment in comments" :key="comment.id">
      <div v-if="vehicleId === comment.vehicleId && comment.dateTime.split('T')[0] === date">
        <span
          data-bs-toggle="modal"
          data-bs-target="#cellCommentModal"
          @click="launchCellCommentModal(comment)"
          role="button"
          class="text-xs rounded-1 px-1 mr"
          :style="`background-color: ${comment.backgroundColor ?? '#ffffff'}; color: ${comment.textColor ?? '#000000'}; margin-left: 2px; font-size:1em;`"
          >
          {{ comment.title }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import emitter from '@/modules/events/emitter'

export default {
  props: ['date', 'vehicleId', 'comments'],
  methods: {
    launchCellCommentModal (comment) {
      emitter.emit('cellCommentModalRequested', { comment: comment })
    }
  }
}
</script>

<style scoped>
.text-xs {
  font-size: .7rem !important;
}
</style>
